
import { Dialog, MenuItem, Select } from '@mui/material';
import { useEffect, useState } from 'react'
import { IoClose } from 'react-icons/io5';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { update_guest, view_guest } from '../Redux/Action/GuestAction';
import { get_event } from '../Redux/Action/EventAction';
import { useTranslation } from 'react-i18next';



const EditModal = ({ Openedit, setOpenedit, guest, debouncedSearch, cachedPages, currentPage, setCurrentPage, setCachedPages, accountType, eventName }) => {
    const { t } = useTranslation('add_guest');
    const handleclose = (e) => {
        e.preventDefault();
        setOpenedit(false);
    }
    const { viewguest } = useSelector((state) => state.Guest)
    const dispatch = useDispatch();
    const { viewevent } = useSelector((state) => state.Create)

    const [input, setinput] = useState({
        event_id: '',
        account_type: '',
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
    })
    useEffect(() => {
        dispatch(get_event());
        if (guest) {
            setinput({
                event_id: guest.event_id || '',
                account_type: guest.account_type.toString() || '',
                first_name: guest.first_name || '',
                last_name: guest.last_name || '',
                email: guest.email || '',
                phone: guest.phone || '',
            });
            console.log(guest.account_type);
        }
    }, [dispatch, guest]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!input.account_type || !input.event_id || !input.first_name || !input.last_name || !input.email || !input.phone) {
            toast.error('Please fill all fields');
            return;
        }
        const payload = {
            event_id: input.event_id,
            account_type: input.account_type.toString(),
            first_name: input.first_name,
            last_name: input.last_name,
            email: input.email,
            phone: input.phone,
            id: guest.id
        };
        const filterAccountType = accountType === 'All' ? null : accountType;
        const filterEventName = eventName === 'All Event' ? null : eventName;

        dispatch(update_guest(guest.id, payload))
            .then(() => {


                const remainingRecords = viewguest.data.data.filter(record => record.id !== guest.id);


                if (remainingRecords.length === 0) {
                    if (currentPage > 1) {
                        setCurrentPage(prevPage => prevPage - 1);
                        dispatch(view_guest(currentPage - 1, debouncedSearch, filterAccountType, filterEventName)).then((res) => {
                            setCachedPages((prev) => ({
                                ...prev,
                                [currentPage - 1]: res,
                            }));
                        });
                    } else {
                        setCachedPages((prev) => ({
                            ...prev,
                            [currentPage]: [],

                        }));

                        dispatch(view_guest(1, debouncedSearch, filterAccountType, filterEventName)).then((res) => {
                            setCachedPages((prev) => ({
                                ...prev,
                                1: res,
                            }));
                        });


                    }
                } else {
                    if (!cachedPages[currentPage]) {
                        dispatch(view_guest(currentPage, debouncedSearch, filterAccountType, filterEventName)).then((res) => {
                            setCachedPages((prev) => ({
                                ...prev,
                                [currentPage]: res,
                            }));
                        });
                    }
                }
                toast.success(t("toast_update"));
                setOpenedit(false);
            })
            .catch((error) => {
                toast.error(t("update_errormsg"));
            });
    }

    return (
        <>
            <Dialog
                open={Openedit}
                onClose={handleclose}
                PaperProps={{
                    sx: {
                        borderRadius: "20px",
                        width: "480px",
                    },
                }}

            >
                <div className="bg-white p-5  flex flex-col gap-5 rounded-[20px] ">
                    <div className="flex   justify-between items-center  w-full ">
                        <div className="text-[20px] font-[600]"> {t("edit_title")}</div>
                        <span onClick={handleclose}><IoClose size={25} className='cursor-pointer' /></span>
                    </div>


                    <form action="" method='POST' onSubmit={handleSubmit} className='bg-white   flex flex-col  grid gap-5   rounded-[20px]'>
                        <div className="grid gap-3 ">


                            <div className="flex flex-col gap-2">
                                <span className='text-[14px] font-[500]  text-[#131415] text-left'>{t("first_name")}</span>
                                <input type='text' placeholder={t("first_name_placeholder")} className='border border-[#c3cbd7] py-[10px] rounded-[10px] px-3 text-[14px] w-full'
                                    name='last_name'
                                    value={input.last_name}
                                    onChange={(e) => setinput({
                                        ...input, [e.target.name]: e.target.value
                                    })}
                                ></input>
                            </div>
                            <div className="flex flex-col gap-2">
                                <span className='text-[14px] font-[500]  text-[#131415] text-left'>{t("last_name")}</span>
                                <input type='text' placeholder={t("last_name_placeholder")} className='border border-[#c3cbd7] py-[10px] rounded-[10px] px-3 text-[14px] w-full'
                                    name='first_name'
                                    value={input.first_name}
                                    onChange={(e) => setinput({
                                        ...input, [e.target.name]: e.target.value
                                    })}
                                ></input>
                            </div>

                            <div className="flex flex-col gap-2">
                                <span className='text-[14px] font-[500]  text-[#131415] text-left'>{t("email")}</span>
                                <input type='text' placeholder={t("email_placeholder")} className='border border-[#c3cbd7] py-[10px] rounded-[10px] px-3 text-[14px] w-full'
                                    name='email'
                                    value={input.email}
                                    onChange={(e) => setinput({
                                        ...input, [e.target.name]: e.target.value
                                    })}
                                ></input>
                            </div>

                            <div className="flex flex-col gap-2">
                                <span className='text-[14px] font-[500]  text-[#131415] text-left'>{t("phone")}</span>
                                <input type='text' placeholder={t("phone_placeholder")} className='border border-[#c3cbd7] py-[10px] rounded-[10px] px-3 text-[14px] w-full'
                                    name='phone'
                                    value={input.phone}
                                    onChange={(e) => setinput({
                                        ...input, [e.target.name]: e.target.value
                                    })}
                                ></input>
                            </div>

                            <div className="flex flex-col gap-2 ">
                                <span className='text-[14px] font-[500] text-[#131415] text-left'>{t("account_type_title")}</span>

                                <Select className='  text-[14px]'
                                    value={input.account_type}

                                    displayEmpty
                                    onChange={(e) => setinput({
                                        ...input, account_type: e.target.value
                                    })}
                                    renderValue={(selected) => {
                                        if (!selected) {
                                            return input.account_type === '0' ? 'Demo' : input.account_type === ' 1' ? 'Event' : '';
                                        }
                                        return input.account_type === '0' ? 'Demo' : input.account_type === '1' ? 'Event' : '';
                                    }}
                                    sx={{
                                        border: 'none', borderRadius: 3, borderColor: '#c3cbd7', height: '44px', fontSize: 14,

                                    }}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                marginTop: '7px',
                                                borderRadius: '8px',

                                            },
                                        },
                                    }}
                                >
                                    <MenuItem value="0" sx={{ fontSize: 14, }}>Demo </MenuItem>
                                    <MenuItem value="1" sx={{ fontSize: 14, }}> Event</MenuItem>
                                </Select>
                            </div>
                            <div className="flex flex-col gap-2">
                                <span className='text-[14px] font-[500]  text-[#131415] text-left'>{t("select_event")}</span>
                                <Select className='  text-[14px]'
                                    value={input.event_id}
                                    displayEmpty
                                    onChange={(e) => setinput({
                                        ...input, event_id: e.target.value
                                    })}
                                    renderValue={(selected) => {
                                        const selectedevent = viewevent && viewevent.data && viewevent.data.find((event) => event.id === selected)
                                        return selectedevent ? selectedevent.name : 'All Event';
                                    }}
                                    sx={{
                                        border: 'none', borderRadius: 3, borderColor: '#c3cbd7', height: '44px', fontSize: 14,

                                    }}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                marginTop: '7px',
                                                borderRadius: '8px',

                                            },
                                        },
                                    }}
                                >
                                    {
                                        viewevent && viewevent.data && viewevent.data.map((obj) => (
                                            <MenuItem key={obj.id} value={obj.id} sx={{ fontSize: 14, }}>
                                                {obj.name}
                                            </MenuItem>

                                        ))
                                    }
                                </Select>
                            </div>
                        </div>
                        <div className="flex gap-5  justify-center">
                            <button className='bg-[#EDF4FF] text-black rounded-lg  h-[40px]  w-full max-w-32 my-1  text-[14px] text-center' onClick={handleclose}>{t("btn_cancel")}</button>
                            <button className='bg-[#3686FF] text-white rounded-lg  h-[40px]  w-full max-w-32 my-1  text-[14px] text-center'  >{t("btn_update")}</button>
                        </div>
                    </form>
                </div>
            </Dialog >
        </>
    )
}

export default EditModal;